module.exports = __webpack_public_path__ + "img/mercedes_thumbnail.64776e01.png";